module.exports = __webpack_public_path__ + "img/button_foreground_candidate.cd0503bb.png";